<div id="container">
    <div *ngFor="let block of blockArray">
        <app-board-column [block]="block"></app-board-column>
    </div>
</div>
